import React from 'react'
import {connect} from 'react-redux'
import UserReport from '../../components/User/UserReport'
import {updateFilterOptions} from '../../actions/filterOptionActions'
import {updateActivityCounts} from '../../actions/userActivityActions'
import {fetchTeams} from '../../../../../shared/javascripts/actions/teamActions'

const mapStateToProps = (state) => {
  return {teams: state.teams, filterOptions: state.filterOptions, userActivityCounts: state.userActivityCounts}
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadTeams: () => {
      dispatch(fetchTeams())
    },
    saveFilterOptions: (options) => {
      dispatch(updateFilterOptions(options))
    },
    saveActivityCounts: (counts={}) => {
      dispatch(updateActivityCounts(counts))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserReport)


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/containers/User/UserReportContainer.jsx